import { BaseNetworkActionHelper } from '../base.network.action.helper';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ErrorRenderData, PopUpRenderData } from '../../../../networkPopUps/types';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../../utils/request';
import { translateFn } from '../../../../../utils/translator.helper';

export class RemoteShellActionHelper extends BaseNetworkActionHelper {
  public async processAction(records: Array<ProtectedEntity>): Promise<PopUpRenderData> {
    // these conditions should only be verified by super analysts
    if (!Application.Main.user.mdrSuperAnalyst) {
      return {
        isError: false,
      };
    }

    const errorMessage: ErrorRenderData = {
      title: translateFn('Cannot start remote shell'),
      errorMessages: [
        translateFn(
          'At least one of the selected endpoints is not eligible for remote shell. Change your selection and try again.'
        ),
      ],
      buttonText: translateFn('Close'),
    };

    if (!Application.Main.checkDefaultConditionsForRemoteShell()) {
      return {
        isError: true,
        errorData: errorMessage,
      };
    }

    const companyIds = this.getUniqCompanyIdsFromRecords(records);
    for (const companyId of companyIds) {
      const companyData = await ConsoleRequest.createRequest<{ data: ProtectedEntity }>({
        dataProviderType: DataProviderType.CORE,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'Company',
        method: 'getCompanyById',
        payload: {
          companyId: companyId,
        },
      });

      if (!this.companyHasMDRRemoteAccess(companyData.data)) {
        return {
          isError: true,
          errorData: errorMessage,
        };
      }
    }

    return {
      isError: false,
    };
  }

  private getUniqCompanyIdsFromRecords(records: Array<ProtectedEntity>): Array<string> {
    const companyIds: Array<string> = [];

    for (const record of records) {
      if (record.company?.id && !companyIds.includes(record.company.id)) {
        companyIds.push(record.company.id);
      }
    }

    return companyIds;
  }

  private companyHasMDRRemoteAccess(company: ProtectedEntity): boolean {
    return Application.Main.checkIfCompanyHasMDRRemoteAccess(company) && Application.Main.checkIfCompanyHasMDR(company);
  }
}
